import React from 'react'
import "./BoostshootRowCard.css"

function BoostshootRowCard({
    heading=null,
    content=null,
    cards
}) {
  return (
    <div className='BoostshootRowCard-container standard-padding-space'>
        <div className='container'>

            <div className="d-flex flex-lg-row flex-column row">
                <div className='content-section mb-5 ps-3'>
                    <h3 className='body-heading'>{heading}</h3>
                    <p className='body-paragraph'>{content}</p>
                </div>

                {cards.map((card, i) => (
                    <div className={` col-lg-4 mb-4 px-lg-4`} >
                        {
                            card?.img &&
                            <div className='w-100 d-flex pb-4 h-25'>
                                <img src='/images/icons/iv-heart-icon.png' className='mx-auto' style={{borderRadius:"50%",maxHeight:"100%"}}/>
                            </div>
                        }
                    <div className={`card-box p-4 ${card?.img?"h-75":"h-100"}`}>
                        <h5 className="sub-heading color-blue" style={{ fontSize: "30px" }}>
                        {card?.number}
                        </h5>
                        <h3 className="body-heading" style={{ fontSize: "1.6rem" }}>
                        {card?.title}
                        </h3>
                        <p className="body-paragraph">{card?.para}</p>
                    </div>
                    </div>
                ))}

                <div className='col-lg-4 col-0 px-0'>
                        <div className='d-lg-flex d-none align-items-center justify-content-end mt-lg-4'>
                            <div className='blue-circle'></div>
                            <div className='blue-line'></div>
                        </div>
                </div>
                <div className='col-lg-4 col-0 px-0'>
                        <div className='d-lg-flex d-none align-items-center justify-content-center mt-lg-4'>
                            <div className='blue-line' style={{width:`calc(50% - 15px)`}}></div>
                            <div className='blue-circle'></div>
                            <div className='blue-line' style={{width:`calc(50% - 15px)`}}></div>
                        </div>
                </div>
                <div className='col-lg-4 col-0 px-0'>
                        <div className='d-lg-flex d-none align-items-center justify-content-start mt-lg-4'>
                            <div className='blue-line'></div>
                            <div className='blue-circle'></div>
                        </div>
                </div>
            </div>
          </div>
    </div>


  )
}

export default BoostshootRowCard